import React from "react";
import { Card } from "antd";
// import { UsergroupAddOutlined } from "@ant-design/icons";
import Slider from "react-slick";
// import { Button } from "../../../components";
import { sliderSettings } from "./slider-settings";
import Profile from "../../../assets/profile-image.png";
import FriendOne from "../../../assets/friends1.png";
import FriendTwo from "../../../assets/friends2.png";
import FriendThree from "../../../assets/friends3.png";

import "./styles.css";

const mockData = [
  {
    name: "uche",
    image: Profile
  },
  {
    name: "uche",
    image: FriendOne
  },
  {
    name: "uche",
    image: FriendTwo
  },
  {
    name: "uche",
    image: FriendTwo
  },
  {
    name: "uche",
    image: FriendThree                                      
  },
  {
    name: "uche",
    image: FriendOne
  },
  {
    name: "uche",
    image: Profile
  },
  {
    name: "uche",
    image: FriendOne
  },
  {
    name: "uche",
    image: FriendTwo
  },
  {
    name: "uche",
    image: FriendTwo
  },
  {
    name: "uche",
    image: FriendThree                                      
  },
  {
    name: "uche",
    image: FriendOne
  },
  {
    name: "uche",
    image: Profile
  },
  {
    name: "uche",
    image: FriendOne
  },
  {
    name: "uche",
    image: FriendThree
  },
  {
    name: "uche",
    image: FriendTwo
  },
  {
    name: "uche",
    image: Profile
  },
  {
    name: "uche",
    image: FriendOne
  },
  {
    name: "uche",
    image: FriendOne
  },
  {
    name: "uche",
    image: FriendTwo
  },
];

const Users = () => {
  return (
    <>
      <Card style={{padding: "14px", borderRadius: 10}}>
        {/* <Button
          type="default"
          className="mr-10 forumBtn"
          icon={<UsergroupAddOutlined />}
          title="Create Forum"
          style={{
            height: "40px",
            borderRadius: "30px",
            borderColor: "#1890ff",
            color: "#1890ff",
          }}
        /> */}
        <Slider {...sliderSettings}>
          {mockData.map((item, index) => (
            <div key={index}>
              <div className="w-11 h-11 2xl:w-16 2xl:h-16 rounded-full flex items-center justify-center">
                <img src={item.image} width={100} />
              </div>
              <div className="w-5 h-5 rounded-full bg-green-400 online"></div>
            </div>
          ))}
        </Slider>
      </Card>
    </>
  );
};

export default Users;
